import { jsx as t, jsxs as i } from "@emotion/react/jsx-runtime";
import { Container as m, StyledAnimatedCircle as n, StyledCircle as s } from "./Status.styled.js";
import { Tooltip as c } from "../Tooltip/index.js";
const x = ({
  animated: o = !1,
  className: r,
  tooltip: l,
  variant: e
}) => /* @__PURE__ */ t(c, { text: l, children: /* @__PURE__ */ i(m, { className: r, children: [
  o ? /* @__PURE__ */ t(n, { variant: e }) : null,
  /* @__PURE__ */ t(s, { variant: e })
] }) });
export {
  x as Status
};
